import React, { useState } from "react";
import { api, whatsappLink } from "@/api";
import { toast } from "sonner";
import { Car, Calendar, Users, ShieldCheck, MessageCircle } from "lucide-react";

const Noleggio = () => {
  const [f, setF] = useState({ nome: "", email: "", telefono: "", messaggio: "Sono interessato al noleggio a lungo termine. Vorrei ricevere maggiori informazioni." });
  const [sending, setSending] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setSending(true);
    try {
      await api.post("/contact", { ...f, messaggio: `[NOLEGGIO LT] ${f.messaggio}` });
      toast.success("Richiesta inviata! Ti ricontatteremo presto.");
      setF({ nome: "", email: "", telefono: "", messaggio: "" });
    } catch { toast.error("Errore, riprova"); }
    setSending(false);
  };

  const inp = "w-full bg-[#0B0B0C] border border-white/10 rounded-sm px-3 py-2.5 text-sm text-white focus:border-[#E1BC56] focus:outline-none";
  const lab = "block text-[10px] tracking-widest uppercase text-zinc-500 mb-1.5 font-display";

  return (
    <div>
      <section className="relative h-[45vh] overflow-hidden">
        <img src="https://images.unsplash.com/photo-1606664515524-ed2f786a0bd6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920" className="w-full h-full object-cover opacity-55" alt="Noleggio" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0B0B0C]/40 via-[#0B0B0C]/70 to-[#0B0B0C]" />
        <div className="absolute inset-0 flex items-center justify-center text-center px-6">
          <div>
            <div className="text-xs tracking-[0.4em] text-[#E1BC56] font-display mb-3">SOLUZIONI PER LA MOBILITÀ</div>
            <h1 className="font-display text-4xl md:text-6xl font-extrabold text-white tracking-widest">NOLEGGIO A LUNGO TERMINE</h1>
            <p className="text-zinc-300 mt-4 max-w-2xl mx-auto">Un&apos;auto sempre nuova, senza pensieri. Formula ideale per privati, professionisti e aziende.</p>
          </div>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 py-16 grid grid-cols-1 md:grid-cols-4 gap-6">
        {[
          { icon: Car, title: "AUTO A SCELTA", desc: "Ampia gamma tra utilitarie, SUV, berline ed elettriche." },
          { icon: Calendar, title: "24-60 MESI", desc: "Durate flessibili con canone mensile fisso." },
          { icon: ShieldCheck, title: "TUTTO INCLUSO", desc: "Bollo, assicurazione, manutenzione e assistenza." },
          { icon: Users, title: "PRIVATI & AZIENDE", desc: "Soluzioni dedicate a partite IVA e aziende." },
        ].map((p) => (
          <div key={p.title} className="bg-[#121214] border border-white/10 rounded-lg p-6 text-center hover:border-[#E1BC56]/40 transition">
            <p.icon className="w-10 h-10 mx-auto text-[#E1BC56] mb-3" strokeWidth={1.4} />
            <div className="font-display text-sm font-bold tracking-widest text-white mb-2">{p.title}</div>
            <div className="text-sm text-zinc-400">{p.desc}</div>
          </div>
        ))}
      </section>

      <section className="max-w-4xl mx-auto px-6 pb-20">
        <div className="text-center mb-8">
          <div className="text-xs tracking-[0.4em] text-[#E1BC56] font-display mb-2">RICHIEDI UN PREVENTIVO</div>
          <h2 className="font-display text-3xl md:text-4xl font-extrabold text-white tracking-widest">PARLIAMONE</h2>
          <p className="text-zinc-400 mt-3">Lascia i tuoi contatti: Luigi ti richiamer&agrave; per costruire insieme la soluzione di noleggio pi&ugrave; adatta a te.</p>
        </div>
        <form onSubmit={submit} className="bg-[#121214] border border-white/10 rounded-lg p-6 md:p-8 space-y-4" data-testid="noleggio-form">
          <div><label className={lab}>Nome *</label><input required className={inp} value={f.nome} onChange={(e) => setF({ ...f, nome: e.target.value })} data-testid="nl-nome" /></div>
          <div><label className={lab}>Email *</label><input required type="email" className={inp} value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} data-testid="nl-email" /></div>
          <div><label className={lab}>Telefono</label><input className={inp} value={f.telefono} onChange={(e) => setF({ ...f, telefono: e.target.value })} data-testid="nl-telefono" /></div>
          <div><label className={lab}>Messaggio</label><textarea rows={4} className={inp} value={f.messaggio} onChange={(e) => setF({ ...f, messaggio: e.target.value })} data-testid="nl-messaggio" /></div>
          <div className="flex flex-col sm:flex-row gap-3">
            <button disabled={sending} type="submit" className="cmc-btn-gold flex-1 py-3 rounded-sm" data-testid="nl-submit">{sending ? "INVIO..." : "INVIA RICHIESTA"}</button>
            <a href={whatsappLink("Ciao LC Auto, vorrei informazioni sul noleggio a lungo termine.")} target="_blank" rel="noreferrer" className="cmc-btn-outline flex-1 py-3 rounded-sm inline-flex items-center justify-center gap-2"><MessageCircle className="w-4 h-4" /> WHATSAPP</a>
          </div>
        </form>
      </section>
    </div>
  );
};

export default Noleggio;
